/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInfolet = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 22H2V2h20zM4 20h16V8H4zM4 6h16V4H4zm15 13h-6v-2h6zm-7 0H5V9h7zm-5-2h3v-6H7zm12-1h-6V9h6zm-4-2h2v-3h-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgInfolet as Infolet };
